import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const ImageCarousel = ({ images }) => {
  if (!Array.isArray(images) || images.length === 0) return null;

  return (
    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      spaceBetween={12}
      loop={images.length > 1}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      className="h-full"
    >
      {images.map((media) => {
        const img = media?.mediaImage5?.[0];
        if (!img?.url) return null;

        return (
          <SwiperSlide key={media.id}>
            <img
              src={img.url}
              alt={img.alt || ""}
              className="w-full h-full object-cover rounded-xl"
              loading="lazy"
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default ImageCarousel;
